<!-- (c) Santosh Sahoo -->
<template>
  <svg viewBox="0 0 40 40" class="select-none">
    <circle v-if="circle" :fill="fill || hashColor(id || name)" r="20" cx="20" cy="20" />
    <rect v-else :fill="fill || hashColor(id || name)" width="40" height="40" :rx="rx" />
    <text font-size="14" dy="5" x="50%" y="50%" text-anchor="middle" fill="#fff">
      {{ getInitials(props.name) }}
    </text>
  </svg>
</template>

<script setup>
  import { getInitials, hashColor } from "../common";

  const props = defineProps({
    id: String,
    name: String,
    fill: String,
    circle: Boolean,
    rx: String,
  });

</script>
